// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"48":"f089c84a","170":"e8108b4c","213":"3d21b807","261":"537ee1fe","310":"46f0f8cc","907":"8297cc21"}[chunkId] + ".chunk.css";
};